import {Injectable} from '@angular/core';
import {Message, MessageService} from 'primeng/api';

@Injectable()
export class ToastService {
    constructor(private messageService: MessageService) {}

    add(message: Message) {
        if (!message.detail) {
            message = {...message, detail: message.summary, summary: undefined};
        }
        this.messageService.add(message);
    }

    success(summary: string, detail?: string) {
        this.add({severity: 'success', summary, detail});
    }

    error(summary: string, detail?: string) {
        this.add({severity: 'error', summary, detail, life: 5000});
    }
}
